<unity-page-container contentHeader="Vendors" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createVendorAction" />
  </ng-container>

  <unity-grid-vendor-shared />
</unity-page-container>
